var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: -2,
    width: 15,
    height: 16,
    rx: 3,
    stroke: "#000",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 1C1.75 0.585786 1.41421 0.25 1 0.25C0.585786 0.25 0.25 0.585786 0.25 1H1.75ZM17 17.75C17.4142 17.75 17.75 17.4142 17.75 17C17.75 16.5858 17.4142 16.25 17 16.25V17.75ZM0.25 1V14H1.75V1H0.25ZM4 17.75H17V16.25H4V17.75ZM0.25 14C0.25 16.0711 1.92893 17.75 4 17.75V16.25C2.75736 16.25 1.75 15.2426 1.75 14H0.25Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyClipboard);
export default __webpack_public_path__ + "static/media/copy-clipboard.c58ab1fe32d0993dc90b4c55d78e26de.svg";
export { ForwardRef as ReactComponent };